import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import  { ProductSearchView } from "./productSearch-view"
import { ProductSearchableSelectorViewModel, productForSelector } from "./productSearchableSelector/productSearchableSelector-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class ProductSearchViewModel extends WindowViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.searcher = new ProductSearchableSelectorViewModel(this,true);
        this.items = ObservableArray.create<item>();
        this.searcher.onSelectionChanged = x=> this.searchProduct(x);
    }
    GetDefaultView(): View <ViewModel> {
        return new ProductSearchView();
    }
    public getTitle(): string {
        return 'جستجوی کالا‌';
    }
    public getTypeId(): string {
        return "VM-501124EB-CCEB-4FB1-BA80-DA792C8E5513"
    }

    public set searcher(v: ProductSearchableSelectorViewModel) { this._searcher = v; } public get searcher(): ProductSearchableSelectorViewModel { return this._searcher;} private _searcher: ProductSearchableSelectorViewModel;
    public set items(v: ObservableArray<item>) { this._items = v; } public get items(): ObservableArray<item> { return this._items;} private _items: ObservableArray<item>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    async refresh() {
        this.searchProduct(this.searcher.selectedItem);
    }
    async searchProduct(product: productForSelector) {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetSingleProductBalanceInfo',{
                ProductId : product.id
            });
            this.items.update(...result.Balances.map((x,i)=>{
                let r = new item(this);
                r.index = i+1;
                r.productCode = product.code;
                r.productName = product.productName;
                r.warehouseName = x.WarehouseName;
                r.balance = x.Balance;
                r.accessibleBalance = x.AccessibleBalance;
                r.lockedNoSaleAmount = x.LockedNoSaleAmount;
                r.inSaleProcess = r.balance - r.accessibleBalance - r.lockedNoSaleAmount;
                r.location = x.Location;
                return r;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

}

export class item extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance;} private _balance: number;
    public set accessibleBalance(v: number) { this._accessibleBalance = v; } public get accessibleBalance(): number { return this._accessibleBalance;} private _accessibleBalance: number;
    public set lockedNoSaleAmount(v: number) { this._lockedNoSaleAmount = v; } public get lockedNoSaleAmount(): number { return this._lockedNoSaleAmount;} private _lockedNoSaleAmount: number;
    public set inSaleProcess(v: number) { this._inSaleProcess = v; } public get inSaleProcess(): number { return this._inSaleProcess;} private _inSaleProcess: number;
    public set location(v: string) { this._location = v; } public get location(): string { return this._location;} private _location: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    
}
